<template>
  <div v-loading="initLoading">
  <div class="ReportDetailPage" style="padding: 20px;width: 500px;background-color: #fafafa">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ReportDetailUnsettle' }" >申报明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="font-size: 25px;margin-top: 15px;">
      <p>申报明细（未发放红利）</p>
    </div>
    <div style="width: 500px; font-family: 宋体; font-size: 25px;font-weight: bold">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" style=" margin-top: 30px;width: 300px" >
        <el-form-item label="申报时间" style="width: 500px">
          <el-col :span="11">
          <el-date-picker
            v-model="ruleForm.startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            :picker-options="startDate" style="width: 100%;">
          </el-date-picker>
          </el-col>
          <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;</el-col>
          <el-col :span="11">
          <el-date-picker
            v-model="ruleForm.endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            :picker-options="endDate" style="width: 100%;">
          </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="供应商" prop="selectedSupplierIds">
          <el-select popper-class="el-select" v-model="ruleForm.selectedSupplierIds" v-if="user!=[]" value-key="id" filterable multiple placeholder="必选"  @change="supplierid()" style="width: 400px">
            <select-all-option v-model="ruleForm.selectedSupplierIds" v-if="userSupplierId == null" @change="supplierid" :data="user" :autoSelect="true"/>
            <el-option
              v-for="item in user"
              :key="item.id"
              :label="item.name"
              :value='item'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="selectedUnsettleType">
          <el-select popper-class="el-select" v-model="ruleForm.selectedUnsettleType" v-if="user!=[]" value-key="id" multiple placeholder="可筛选，不筛选则导出全部"  style="width: 400px">
            <select-all-option v-model="ruleForm.selectedUnsettleType" :data="selectUnsettleType"/>
            <el-option
              v-for="item in selectUnsettleType"
              :key="item.id"
              :label="item.type"
              :value='item'
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="品牌" prop="selectParentBrands" >
          <el-select v-model="ruleForm.selectedParentBrands"  :popper-append-to-body="false" popper-class="selectinfo" multiple placeholder="请选择" style="width: 400px;color: #EF6C00" value-key="id"  @change="selectParentBrandss()" :disabled="ruleForm.selectedSupplierIds != '' ?false:true">
            <el-option-group
              v-for="group in dataInfos"
              :key="group.id"
              :label="group.name">
              <el-option
                v-for="item in group.brands"
                :key="item.id"
                :label="item.parentBrand"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="品类" prop="selectBrands">
          <el-select  v-model.number="ruleForm.selectedBrands" multiple placeholder="请选择" style="width: 400px" value-key="id"  @change="selectBrandss()" :disabled="ruleForm.selectedParentBrands != '' ?false:true">
            <el-option-group
              v-for="group in selectBrands"
              :key="group.id"
              :label="group.parentBrand">
              <el-option
                v-for="(item) in group.brand"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="selectProducts">
          <el-select  v-model.number="ruleForm.selectedProducts" multiple placeholder="请选择"  value-key="id" style="width: 400px" :disabled="ruleForm.selectedBrands != '' ?false:true">
            <el-option-group
              v-for="group in selectProducts"
              :key="group.id"
              :label="group.name">
              <el-option
                v-for="item in group.products"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>-->
        <el-form-item label="区域" prop="selectRegionals">
          <el-select popper-class="el-select" v-model.number="ruleForm.selectedRegionals" multiple style="width: 400px" value-key="id" @change="selectRegionalss" placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm.selectedSupplierIds != '' && ruleForm.selectedSupplierIds.length === 1 ?false:true">
            <select-all-option v-model="ruleForm.selectedRegionals" group-value="regionals" @change="selectRegionalss" :data="selectRegionals"/>
            <el-option-group
              v-for="group in selectRegionals"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.regionals"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="省份" prop="selectProvinces">
          <el-select popper-class="el-select" v-model.number="ruleForm.selectedProvinces"  style="width: 400px" value-key="id" multiple placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm.selectedRegionals != '' ?false:true">
            <select-all-option v-model="ruleForm.selectedProvinces" group-value="children" @change="selectRegionalss" :data="selectProvinces"/>
            <el-option-group
              v-for="group in selectProvinces"
              :key="group.name"
              :label="group.name">
              <el-option
                v-for="item in group.children"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="margin-left: 10vw">
        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633"   :loading="loading" @click="excel()">导出excel</el-button>
<!--        <el-button style="color: white; variant:'outlined';border-color: #FF6633; background-color: #FF6633" :loading="loadings"  @click="dialogFormVisible = true">推送邮件</el-button>-->
      </div>
    </div>
    <!-- Form -->
<!--    <el-dialog title="请选择你需要推送到的邮箱" :visible.sync="dialogFormVisible"   center width="30%">-->
<!--      <el-select v-model="ruleForm.javaMail" placeholder="请选择通路管理助手的注册用户" style="width: 100%;">-->
<!--        <el-option-->
<!--          v-for="item in options"-->
<!--          :key="item.emailAddress"-->
<!--          :label="(item.name+item.emailAddress)"-->
<!--          :value="item.emailAddress">-->
<!--        </el-option>-->
<!--      </el-select>-->
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button  style="width: 40%;background-color: #FFCCCC;color: white "  @click="dialogFormVisible = false">取 消</el-button>-->
<!--        <el-button style="width: 40%;background-color: #FFCCCC;color: white " @click="dialogFormVisibles()">确 定</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
  </div>
</template>

<script>
import { allUser, Mailselect, unsettleExcel } from '@/api/ReportDetailPage'
import selectAllOption from "@/components/selectAllOption";
export default {
  components: {selectAllOption},
  data () {
    return {
      // 判断时间的限制
      startDate: {
        disabledDate: (time) => {
          if (this.ruleForm.endDate) {
            return time.getTime() > Math.min(new Date(this.ruleForm.endDate).getTime(),new Date(this.umEndDate).getTime()) || time.getTime() < new Date(this.umStartDate).getTime() - 86400000
          } else {
            return time.getTime() < new Date(this.umStartDate).getTime() - 86400000 || time.getTime() > new Date(this.umEndDate).getTime()
          }
        }
      },
      endDate: {
        disabledDate: (time) => {
          if (this.ruleForm.startDate) {
            return time.getTime() < Math.max(new Date(this.ruleForm.startDate).getTime(),new Date(this.umStartDate).getTime()) || time.getTime() > new Date(this.umEndDate).getTime()
          } else {
            return time.getTime() < new Date(this.umStartDate).getTime() - 86400000 || time.getTime() > new Date(this.umEndDate).getTime()
          }
        }
      },
      ruleForm: {
        selectedSupplierIds: '',
        endDate: null,
        startDate: null,
        selectedParentBrands: [],
        selectedBrands: [],
        selectedProducts: [],
        selectedRegionals: [],
        selectedProvinces: [],
        selectedUnsettleType: [],
        javaMail: ''
      },
      rules: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      selectParentBrands: [ { brands: [] } ],
      selectBrands: [],
      selectProducts: [],
      selectRegionals: [],
      selectProvinces: [],
      selectUnsettleType: [],
      token: '',
      selectedSupplierId: [],
      dataInfos: [],
      loading: false,
      loadings: false,
      options: [],
      dialogFormVisible: false,
      userSupplierId:'',
      initLoading:true,
      umStartDate: null,
      umEndDate: null
    }
  },
  created () {
    this.token = localStorage.getItem('token')
    this.$store.commit('addTips',['大部分字段可选择性填写，若不填写则表示导出全部。可选填的字段包括[类型]、[区域]、[省份]'])
    this.userSupplierId = localStorage.getItem("userSupplierId");
    allUser(this.token, localStorage.getItem('dashboardSales') == 1 ? null : localStorage.getItem('userSupplierId')).then(res => {
      if (res.data.suppliers != null) {
        this.user = res.data.suppliers
        this.selectUnsettleType = res.data.unsettleType
        this.umStartDate = res.data.umStartDate
        this.umEndDate = res.data.umEndDate
        this.ruleForm.endDate = this.getNowTime()
        this.ruleForm.startDate = this.getStartTime()
      }
      this.initLoading = false;
    }).catch(error => {
      let status = error.response.status;
      if (status == 500){
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    })
    this.Mailselect();
  },
  methods: {
    supplierids (lists) {
      let dataInfo = []
      lists.forEach((item1, index) => {
        let data = {
          id : index,
          name : item1.name,
          brands : []
        }
        item1.brands.forEach((item, index) => {
          let { parentBrand } = item
          if (!data.brands[parentBrand]) {
            data.brands[parentBrand] = {
              id: item.id,
              parentBrand: item.parentBrand,
              brand: [{
                id: item.id,
                name: item.name,
                products: item.products
              }]
            }
          }
        })
        let list=Object.values(data.brands)
        data.brands=list
        dataInfo.push(data)
      })
      this.dataInfos = dataInfo
    },
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.selectedSupplierIds != '') {
        this.selectParentBrands = this.ruleForm.selectedSupplierIds
        this.supplierids(this.selectParentBrands)
        this.selectRegionals = this.ruleForm.selectedSupplierIds
        let parentBrands=[];
        if (this.ruleForm.selectedParentBrands!= ''){
          this.ruleForm.selectedParentBrands.forEach((item, index) => {
            this.selectParentBrands.forEach((e, i) => {
              e.brands.forEach((t, m) => {
                if(item.parentBrand == t.parentBrand){
                  parentBrands[item.parentBrand]=item
                }
              })
            })
          })
          this.ruleForm.selectedParentBrands = Object.values(parentBrands);
          this.selectParentBrandss ()
        }
      } else {
        this.ruleForm.selectedParentBrands = []
        this.ruleForm.selectedBrands = []
        this.ruleForm.selectedProducts = []
        this.ruleForm.selectedRegionals = []
        this.ruleForm.selectedProvinces = []
      }
    },
    selectParentBrandss () {
      // 根据选择的品牌赋值给品类
      if (this.ruleForm.selectedParentBrands != '') {
        this.selectBrands = this.ruleForm.selectedParentBrands
        let selectedBrands=[]
        if (this.ruleForm.selectedBrands != ''){
          this.ruleForm.selectedBrands.forEach((item, index) => {
            this.selectBrands.forEach((t, i) => {
              t.brand.forEach((e, j) => {
                if(item.name == e.name){
                  selectedBrands[item.name]=item;
                }
              })
            })
          })
          this.ruleForm.selectedBrands = Object.values(selectedBrands)
          this. selectBrandss ()
        }
      } else {
        this.ruleForm.selectedBrands = []
        this.ruleForm.selectedProducts = []
      }
    },
    selectBrandss () {
      // 根据选择的品类赋值给产品
      if (this.ruleForm.selectedBrands != '') {
        this.selectProducts = this.ruleForm.selectedBrands
        console.log(this.selectProducts)
        console.log(this.ruleForm.selectedProducts)
        let selectedProducts=[]
        if (this.ruleForm.selectedProducts !=''){
          this.ruleForm.selectedProducts.forEach((item, index) => {
            this.selectProducts.forEach((t, i) => {
              t.products.forEach((e, j) => {
                if (e.name == item.name){
                  selectedProducts[item.name]=item
                }
              })
            })
          })
          this.ruleForm.selectedProducts = Object.values(selectedProducts)
        }
      } else {
        this.ruleForm.selectedProducts = []
      }
    },
    selectRegionalss () {
      // 根据选择的区域赋值给不同的省份
      if (this.ruleForm.selectedRegionals != '' && this.ruleForm.selectedRegionals.length >0) {
        this.selectProvinces = this.ruleForm.selectedRegionals
      }else {
        this.ruleForm.selectedProvinces = []
      }
    },
    excel () {
      this.token = localStorage.getItem('token')
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.selectedSupplierIds != '') {
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm.selectedBrands != '') {
        } else {
          this.ruleForm.selectedBrands = this.ruleForm.selectedParentBrands
        }
        this.loading = true
        this.ruleForm.javaMail=''
        unsettleExcel(this.token, this.ruleForm,localStorage.getItem('managerId')).then(res => {
          if (res == null) {
            this.$notify.error({
              message: '导出失败',
              title: '失败',
              position: 'bottom-right'
            })
            this.loading = false
          } else {
              this.handleDownload(res)
              this.$notify({
                type: 'success',
                message: '导出成功',
                title: '成功',
                position: 'bottom-right'
              })
              this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500){
            this.$notify.error({
              message: '导出失败，请联系管理员',
              title: '失败',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    // 处理默认选中当前日期
    getNowTime () {
      let now = new Date(Math.min(new Date().getTime(), new Date(this.umEndDate).getTime()))
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      return defaultDate
      // this.$set(this.ruleForm, 'endDate', defaultDate)
    },
    getStartTime(){
      let now = new Date(this.ruleForm.endDate)
      now = new Date(now.getTime() + 24*3600*1000)
      now.setMonth(now.getMonth()-1);
      now = new Date(Math.max(now.getTime(),new Date(this.umStartDate).getTime()))
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    handleDownload (res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    dialogFormVisibles () {
      if (this.ruleForm.selectedSupplierIds != '') {
        if (this.ruleForm.javaMail != '') {
          this.dialogFormVisible = false
          if (this.ruleForm.selectedBrands != '') {
          } else {
            this.ruleForm.selectedBrands = this.ruleForm.selectedParentBrands
          }
          this.loadings = true
          excel(this.token, this.ruleForm).then(res => {
            if (res !== null) {
              if (res.status === 200) {
                this.$notify({
                  type: 'success',
                  message: '推送成功',
                  title: '成功',
                  position: 'bottom-right'
                })
                this.loadings = false
              }
            }
          }).catch(error => {
            let status = error.response.status;
            if (status == 500){
              this.open4()
            }
            this.loadings = false
          })
        } else {
          this.$notify({
            title: '警告',
            message: '请至少选择一个邮箱地址',
            type: 'warning',
            position: 'bottom-right'
          })
        }
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    open4 () {
      this.$notify.error({
        title: '错误',
        message: '推送失败，请联系管理员',
        position: 'bottom-right'
      })
    },
    Mailselect () {
      Mailselect(this.token).then(res => {
        if (res.data != '') {
          console.log(res)
          this.options = res.data
        }
      }).catch(error => {
        let status = error.response.status
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '邮箱地址获取失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    }
  }
}
</script>

<style soped>
.el-select .el-input.is-focus .el-input__inner{
  border-color: #EF6C00;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected{
  color: #EF6C00
}
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/*.el-dialog__header {
  background: #EF6C00 !important;
}
.el-dialog__footer {
  background-color: #FFCCCC !important;
}
.el-dialog{
  background: #EF6C00 !important;
}
.el-dialog__title{
  color: white !important
}*/
</style>
